/**
 * Call quality — the pre-call connection test and in-call events.
 *
 * Mirrors backend/app/schemas/call_quality.py. Events are codes only; they
 * land in the audit log, which never holds free text.
 */
import { apiFetch } from '../api';

export type DoctorCallEvent = 'audio_only_on' | 'audio_only_off' | 'reconnected' | 'video_established';
export type CallEventTrigger = 'auto' | 'manual';

export interface NetworkCheckResponse {
  room_id: string;
  token: string;
  endpoint: string;
  expires_in_seconds: number;
}

export interface DoctorCallEventResponse {
  consultation_id: string;
  video_established_at: string | null;
}

/** A throwaway room and a publish-only token for a few-second upload test. */
export function startNetworkCheck(): Promise<NetworkCheckResponse> {
  return apiFetch<NetworkCheckResponse>('/v1/doctor/network-check', { method: 'POST' });
}

export function reportCallEvent(
  consultationId: string,
  event: DoctorCallEvent,
  trigger?: CallEventTrigger,
): Promise<DoctorCallEventResponse> {
  return apiFetch<DoctorCallEventResponse>(`/v1/doctor/consultations/${consultationId}/call-events`, {
    method: 'POST',
    body: JSON.stringify(trigger ? { event, trigger } : { event }),
  });
}
